import { ChangeEvent } from "react";
import { useIntl } from "react-intl";

import {
  Form,
  FormGroup,
  Label,
  Loading,
  Msg,
  Textarea,
} from "@shared/components";

import { REASON_SUBMISSION_MAX_LENGTH } from "../utils";

interface FairnessFormStepProps {
  fairnessComment: string;
  onFairCommentChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  loading: boolean;
  validationError: boolean;
}

export const FairnessFormStep = ({
  fairnessComment,
  onFairCommentChange,
  loading,
  validationError,
}: FairnessFormStepProps) => {
  const intl = useIntl();
  const placeholder = intl.formatMessage({
    id: "editor-exam-details.modals.fairnessForm.placeholder",
  });
  const validationMessage = intl.formatMessage(
    { id: "validation.string.maxLength" },
    { length: REASON_SUBMISSION_MAX_LENGTH },
  );
  return (
    <div className="code-editor-exam-detail__fairness-form">
      <Loading isOpen={loading} hide={false} />
      <Form>
        <FormGroup>
          <Label
            title={<Msg id="editor-exam-details.modals.fairnessForm.title" />}
            className="code-editor-exam-detail__fairness-form__label"
          />
          <Textarea
            className="code-editor-exam-detail__fairness-form__textarea-container"
            textareaClassName="code-editor-exam-detail__fairness-form__textarea"
            placeholder={placeholder}
            value={fairnessComment}
            onChange={onFairCommentChange}
          />
          {validationError && (
            <p className="code-editor-exam-detail__fairness-form__error">
              {validationMessage}
            </p>
          )}
        </FormGroup>
      </Form>
    </div>
  );
};
